var typedArrayConstructor = require('../internals/typed-array-constructor'); // `Uint8Array` constructor
// https://tc39.github.io/ecma262/#sec-typedarray-objects


typedArrayConstructor('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});